import { useContext } from 'react';
import { errorReducerActionTypes } from '../../../redusers/error-reducer';
import { paymentReducerActionTypes } from '../../../redusers/payment-reducer';
import ConfirmBookingButton from '../../../ui-components/confirm-button';
import { bookingState } from '../client-state/booking-state-context';
import useBookingTracking from '../../../Hooks/useBookingTracking';
import { loadingReducerActionTypes } from '../../../redusers/loading-reducer';
import { customerReducerActionTypes } from '../../../redusers/customer-reducer';
import { put } from '../../../Utils/fetch';
import useLocalize from '../../../Hooks/useLocalize';
import useBookingShop from '../server-data/use-booking-shop';

const GoToCheckoutButtonWithData = () => {
  const { data: shop } = useBookingShop();
  const { state, dispatch } = useContext(bookingState);
  const localize = useLocalize();
  const track = useBookingTracking();

  const shopHasItems = shop?.items && shop?.items?.length > 0;
  const numberOfSteps = shopHasItems ? 4 : 3;

  const updateCustomer = async () => {
    try {
      dispatch({ type: loadingReducerActionTypes.CUSTOMER, payload: true });
      const updatedCustomer = await put(
        `Customers/${state.booking.customerId}/updateCustomerAlt`,
        state.customer.customer
      );

      return dispatch({
        type: customerReducerActionTypes.UPDATE_CUSTOMER,
        payload: updatedCustomer,
      });
    } catch (error) {
      throw error;
    }
  };

  return (
    <ConfirmBookingButton
      id="step4NextButton"
      loading={state.loading.customer}
      dependencies={[
        { key: 'customer.formValid', value: true },
        { key: 'currentStep', value: numberOfSteps },
        {
          key: 'terms.termsChecked',
          value: true,
          errorType: errorReducerActionTypes.TERMS,
          clickable: true,
        },
        {
          key: 'terms.newsletterSubscribed',
          value: [true, false],
          errorType: errorReducerActionTypes.NEWSLETTER,
          clickable: true,
        },
      ]}
      onClick={async () => {
        try {
          dispatch({
            type: errorReducerActionTypes.BOOKING_CREATE,
            payload: false,
          });
          await updateCustomer();

          dispatch({
            type: paymentReducerActionTypes.UPDATE_SHOW_PAYMENT_MODAL,
            payload: true,
          });

          track({ type: 'CHECKOUT', product: state.booking, step: 1 });
          track({ type: 'ADD_SHIPPING_INFO', product: state.booking });
          track({ type: 'GO_TO_CHECKOUT_PAGE' });
        } catch (error) {
          console.error(error);
          dispatch({
            type: errorReducerActionTypes.BOOKING_CREATE,
            payload: 'UnknownError',
          });
        }
      }}
      onError={(errorType) => {
        if (errorType) {
          if (errorType === errorReducerActionTypes.TERMS) {
            dispatch({
              type: errorReducerActionTypes.TERMS,
              payload: 'true',
            });
          }

          if (errorType === errorReducerActionTypes.NEWSLETTER) {
            dispatch({
              type: errorReducerActionTypes.NEWSLETTER,
              payload: 'true',
            });
          }
        }
      }}
    >
      {`${localize('product.goToCheckout')}`}
    </ConfirmBookingButton>
  );
};

export default GoToCheckoutButtonWithData;
